<template>
  <div class="subject-view">
    <div v-if="subject && !loading">
      <Question
        v-if="randKey"
        :question="randQuestion"
        @loaded="scrollToQuestion"
        @answered="handleCorrectAnswer"
        @failed="handleFailedAnswer"
      />
    </div>
    <div v-else class="spinner">
      <CubeSpinner background="rgb(50, 64, 80)" />
    </div>
  </div>
</template>

<script>
import axios from "@/http";
import Question from "@/components/Question";
import CubeSpinner from "@/components/CubeSpinner.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SubjectView",
  components: {
    Question,
    CubeSpinner,
  },
  data() {
    return {
      randKey: null,
      fails: [],
      answered: [],
      subject: null,
      loading: false,
    };
  },
  computed: {
    randQuestion() {
      return this.subject.questions[this.randKey];
    },
    //subject () {
    //return this.getSubjectBySlug(this.$route.params.slug);
    //},
    ...mapGetters([
      "tokenHeader",
      "currentQuestionGroup",
      "currentQuestionClass",
      "currentQuestionSubject",
      "subjects",
    ]),
  },
  watch: {
    "$route.params.slug": function () {
      this.subject = this.subjects.find(
        (s) => s.slug == this.$route.params.slug
      );
      this.loadQuestions();
    },
  },
  async mounted() {
    this.setPageType(this.$route.meta.pageType);
    this.setCurrentQuestionClass(this.$route.meta.classSlug);
    this.setCurrentQuestionGroup(this.$route.params.group_slug);
    this.setCurrentQuestionSubject(this.$route.params.slug);

    // WHY?!
    let vm = this;
    this.getSubjectBySlug(this.$route.params.slug).then((result) => {
      vm.subject = result;
      vm.loadQuestions();
    });
  },
  methods: {
    async loadQuestions() {
      this.loading = true;
      if (!this.subject) {
        await this.loadSubjects();
        this.subject = this.subjects.find(
          (s) => s.slug == this.$route.params.slug
        );
      }
      try {
        let result = await axios.get(
          process.env.VUE_APP_FLL_ROOT_API +
            "/" +
            this.subject.route +
            "/questions",
          {
            headers: {
              ...this.tokenHeader,
            },
          }
        );
        this.subject.questions = result.data;
      } catch (error) {
        // TODO: handle error
        console.error(error); // eslint-disable-line
      }
      this.loadRandomQuestion();
      this.loading = false;
    },
    loadRandomQuestion() {
      if (this.answered.length == Object.keys(this.subject.questions).length) {
        this.answered = [];
      }
      let roll = Math.floor(Math.random() * 11);
      if (roll >= 5 && this.fails.length > 0) {
        let rndFail = this.fails[Math.floor(Math.random() * this.fails.length)];
        if (rndFail != this.randKey) {
          this.randKey = rndFail;
          return;
        }
      }
      let keys = Object.keys(this.subject.questions);
      let randKey = null;
      let maxTries = 300;
      let tries = 0;
      do {
        tries++;
        randKey = keys[Math.floor(Math.random() * keys.length)];
      } while (this.answered.includes(randKey) && tries < maxTries);
      this.randKey = randKey;
      //this.randKey = 6;
      this.scrollToQuestion();
    },
    handleCorrectAnswer() {
      if (!this.answered.includes(this.randKey)) {
        this.answered.push(this.randKey);
      }
      if (this.fails.includes(this.randKey)) {
        this.fails = this.fails.filter((key) => {
          return key != this.randKey;
        });
      }
      if (this.randQuestion.follow_up_question !== null) {
        this.randKey = this.randQuestion.follow_up_question;
      } else {
        this.loadRandomQuestion();
      }
    },
    handleFailedAnswer() {
      if (!this.fails.includes(this.randKey)) {
        this.fails.push(this.randKey);
      }
      this.loadRandomQuestion();
    },
    scrollToQuestion() {
      //this.$refs.title.scrollIntoView({
      //behavior: "smooth",
      //block: "start",
      //inline: "nearest"
      //});
    },
    async loadSubjects() {
      this.setSubjects([]);
      let result = await axios.get(
        process.env.VUE_APP_FLL_ROOT_API +
          "/classes/" +
          this.$route.meta.classSlug +
          "/subjects",
        {
          headers: {
            ...this.tokenHeader,
          },
        }
      );
      this.setSubjects(result.data);
    },
    ...mapActions([
      "setCurrentQuestionClass",
      "setCurrentQuestionGroup",
      "setCurrentQuestionSubject",
      "setPageType",
      "getSubjectBySlug",
      "setSubjects",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.spinner {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 50px;
}
</style>
